import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isBookingsLastName(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.BOOKINGS_LAST_NAME && typeof label === 'string' && typeof value === 'string';
}
function _formatBookingsLastName(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatBookingsLastName(submission) {
  if (isBookingsLastName(submission)) {
    return _formatBookingsLastName(submission);
  }
  return undefined;
}
//# sourceMappingURL=bookings-last-name-preview.js.map